export const FETCH_COMPANY_WEEKDAYS = "FETCH_COMPANY_WEEKDAYS";
export const EDIT_COMPANY_WEEKDAYS = "EDIT_COMPANY_WEEKDAYS";
